import {
  type CreateCuisineRequest,
  type CuisineDetail,
  CuisineDetailSchema,
  type CuisineListQuery,
  type CuisineListResponse,
  CuisineListResponseSchema,
  type UpdateCuisineRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const listCuisines = async (query: CuisineListQuery): Promise<CuisineListResponse> => {
  const { data } = await apiClient.get<unknown>('/cuisines', { params: query });
  return CuisineListResponseSchema.parse(data);
};

export const getCuisine = async (id: string): Promise<CuisineDetail> => {
  const { data } = await apiClient.get<unknown>(`/cuisines/${id}`);
  return CuisineDetailSchema.parse(data);
};

export const createCuisine = async (payload: CreateCuisineRequest): Promise<CuisineDetail> => {
  const { data } = await apiClient.post<unknown>('/cuisines', payload);
  return CuisineDetailSchema.parse(data);
};

export const updateCuisine = async (
  id: string,
  payload: UpdateCuisineRequest,
): Promise<CuisineDetail> => {
  const { data } = await apiClient.patch<unknown>(`/cuisines/${id}`, payload);
  return CuisineDetailSchema.parse(data);
};

export const deleteCuisine = async (id: string): Promise<void> => {
  await apiClient.delete(`/cuisines/${id}`);
};

export const bulkDeleteCuisines = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/cuisines/bulk-delete', { ids });
  return data;
};

export const bulkSetCuisinesStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/cuisines/bulk-set-status', { ids, isActive });
  return data;
};
